module.exports = __webpack_public_path__ + "svg/dotnetcore.bed12d.svg";